import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'

export default function ForbiddenPage({ settings }) {
  const phone = settings?.phone || '22 18 73 30'
  const bookingUrl = settings?.booking_url || 'https://service.dinbilpartner.dk/book-tid'

  return (
    <>
      <MetaTags
        title="Adgang nægtet (403) | EK Biler v/Steen Svensson Ek"
        description="Du har ikke adgang til denne side."
      />

      <section className="min-h-[70vh] bg-white flex items-center justify-center py-20 px-4 sm:px-6">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-amber-50 text-amber-600 text-3xl font-extrabold mb-2 border border-amber-200">
            403
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
            Adgang nægtet
          </h1>

          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
            Du har desværre ikke adgang til denne ressource på serveren. Du kan gå tilbage til
            forsiden eller kontakte os direkte.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#14171a] hover:bg-[#20252b] text-white px-6 py-3 rounded-xl font-bold text-sm transition-colors shadow-sm"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white px-6 py-3 rounded-xl font-bold text-sm transition-colors shadow-sm"
            >
              <i className="fa-solid fa-calendar-check" aria-hidden="true" />
              <span>Book tid</span>
            </a>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-800 px-6 py-3 rounded-xl font-bold text-sm transition-colors"
            >
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>Kontakt os ({phone})</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
